import { Alert } from 'react-bootstrap';
import { Verification } from 'src/typings/api-models.generated';
import { AlertWrapper } from 'src/ui/shared/components/bootstrap/alerts/AlertWrapper';

interface Props {
    verification: Verification;
}

export const VerificationDeniedFeedback = ({ verification }: Props): React.ReactElement | null => {
    if (verification.status !== 'denied') {
        return null;
    }

    return (
        <AlertWrapper variant="info" icon="info-circle">
            <Alert.Heading>Denied feedback</Alert.Heading>
            {verification.feedback || <em>No feedback provided</em>}
        </AlertWrapper>
    );
};
